import { useCallback } from 'react'
import format from 'date-fns/format'

import axios from 'utils/axios'

const useManualOrder = () => {
  const createManualOrder = useCallback(async (values) => {
    const formData = new FormData()

    // Required fields
    formData.append('clientid', values.clientId)
    formData.append('description', values.orderProgramName)
    formData.append('internal_client_name', values.internalClientName)
    formData.append(
      'internal_order_description',
      values.internalOrderDescription
    )
    formData.append('date_expected', format(values.dueDate[0], 'yyyy-MM-dd'))
    formData.append('approval_method', values.approvalMethod)
    formData.append('print_type', values.printType)
    formData.append('plex', values.plex)
    formData.append('fold_type', values.foldType)
    formData.append('mode', values.mode)
    formData.append('number_clicks', values.numberClicks)
    formData.append('mailing_method', values.delivMethod)
    formData.append('meter_class', values.meterClass)

    // Optional fields
    formData.append('comments', values.comments || '')
    formData.append('number_envelopes', values.numberEnvelopes || '0')
    formData.append('outgoing_envelope_sku', values.outgoingSku || '')
    formData.append('inserts', values.inserts || '')
    formData.append(
      'machine_inserted',
      values.machineInserted === 'Yes' ? 'true' : 'false'
    )

    // Only append static_package_pages if machine inserted is Yes and value exists
    if (values.machineInserted === 'Yes' && values.staticPageCount) {
      formData.append('static_package_pages', values.staticPageCount)
    }

    // Add paper SKUs - note the change to only include stock and sku_id
    values.papers.forEach((paper, index) => {
      if (paper.sku_id) {
        formData.append(`paper[${index + 1}][stock]`, paper.stock)
        formData.append(`paper[${index + 1}][sku_id]`, paper.sku_id)
      }
    })

    // Add mail files
    values.mailFiles.forEach((file, index) => {
      formData.append(`mailing_file[${index}]`, file)
    })

    const response = await axios.post('/manual-orders', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  }, [])

  return {
    createManualOrder,
  }
}

export default useManualOrder
